import { APP } from './app.js';
const dateFmt = new Intl.DateTimeFormat(APP.LOCALE, {
    timeZone: APP.TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});
const timeFmt = new Intl.DateTimeFormat(APP.LOCALE, {
    timeZone: APP.TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit'
});
const isoDayFmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP.TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});
/** Дата в формате дд.мм.гггг по московскому времени. */
export function formatDate(value) {
    return dateFmt.format(new Date(value));
}
/** Дата и время в формате дд.мм.гггг чч:мм по московскому времени. */
export function formatDateTime(value) {
    const d = new Date(value);
    return `${dateFmt.format(d)} ${timeFmt.format(d)}`;
}
/** Время чч:мм по московскому времени. */
export function formatTime(value) {
    return timeFmt.format(new Date(value));
}
/** Сегодняшний день по Москве: «ГГГГ-ММ-ДД». */
export function todayIso(now = new Date()) {
    return isoDayFmt.format(now);
}
/** Прибавляет дни к дню «ГГГГ-ММ-ДД». */
export function addDays(day, days) {
    const [y, m, d] = day.split('-').map(Number);
    const t = new Date(Date.UTC(y, m - 1, d + days));
    return t.toISOString().slice(0, 10);
}
/** Проверка строки дня «ГГГГ-ММ-ДД». */
export function isIsoDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const [y, m, d] = value.split('-').map(Number);
    const t = new Date(Date.UTC(y, m - 1, d));
    return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d;
}
/** День «ГГГГ-ММ-ДД» → «дд.мм.гггг». Пусто → «—». */
export function formatDay(day) {
    if (!day)
        return '—';
    const [y, m, d] = day.split('-');
    return `${d}.${m}.${y}`;
}
/** Число с разделителем разрядов и двумя знаками: «1 234,50». */
export function formatAmount(value) {
    const fixed = (Math.round(value * 100) / 100).toFixed(2);
    const [int, frac] = fixed.split('.');
    return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')},${frac}`;
}
/** Сумма в валюте: «1 234,50 CNY». */
export function formatMoney(value) {
    return `${formatAmount(value)} ${APP.CURRENCY}`;
}
/** Цена или «—». */
export function formatPrice(value) {
    return value === null || value === undefined ? '—' : formatAmount(value);
}
/** Вес в кг: до трёх знаков, без лишних нулей, с запятой. */
export function formatWeight(value) {
    return String(Math.round(value * 1000) / 1000).replace('.', ',');
}
/** Целое число с разделителем разрядов. */
export function formatInt(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
}
//# sourceMappingURL=format.js.map